"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const redux_1 = require("redux");
const reducers_1 = tslib_1.__importDefault(require("./reducers"));
const store = redux_1.createStore(reducers_1.default);
exports.default = store;
//# sourceMappingURL=store.js.map